<div class="content-container m-0">
    <div class="d-flex my-4">
        <div class="login-form mx-auto">
            <div class="d-flex mb-3 flex-column">
                <img class="logo p-4" src="/assets/logo-large.png" alt="Tiwi Land Council" />
            </div>

            @if (loading) {
                <ngxh6-loading-or-error></ngxh6-loading-or-error>
            } @else if (invalid) {
                <div class="alert alert-warning" role="alert">
                    <strong>This invitation link is no longer valid.</strong>
                    <div class="small mt-1">Use <a routerLink="/forgot-password">Forgot password</a> on the sign-in page and we'll send you a new one.</div>
                </div>
            } @else if (success) {
                <div class="alert alert-success" role="alert">
                    <strong>Your password is set.</strong>
                    <div class="small mt-1">You can now sign in with {{ email }}.</div>
                </div>
                <button type="button" class="btn btn-primary ms-0 w-100" (click)="goToLogin()">Go to sign in</button>
            } @else {
                <h1 class="h4 mt-0">Welcome{{ firstName ? ', ' + firstName : '' }}</h1>
                <p class="text-muted">Choose a password to finish setting up your account for {{ email }}.</p>

                @if (error) {
                    <div class="alert alert-danger" role="alert">{{ error }}</div>
                }

                <form [formGroup]="form" (ngSubmit)="submit()">
                    <div class="form-group">
                        <label class="form-label" for="invite_password">Password</label>
                        <input class="form-control" type="password" id="invite_password" formControlName="password" autocomplete="new-password" />
                        <div class="form-text">At least 10 characters.</div>
                    </div>

                    <div class="form-group">
                        <label class="form-label" for="invite_repeat">Confirm password</label>
                        <input class="form-control" type="password" id="invite_repeat" formControlName="repeatPassword" autocomplete="new-password" />
                        @if (form.hasError('passwordMismatch') && form.get('repeatPassword')?.touched) {
                            <div class="text-danger small mt-1">Those passwords don't match.</div>
                        }
                    </div>

                    <button type="submit" class="btn btn-primary ms-0 w-100 mt-3" [disabled]="form.invalid || saving">
                        {{ saving ? 'Saving…' : 'Set my password' }}
                    </button>
                </form>
            }
        </div>
    </div>
</div>
